export const getRegion = () =>
  (process.env.VUE_APP_REGION || "au").toLowerCase();

export const isRegion = (region) =>
  getRegion().toLowerCase() === region.toString().toLowerCase();

export default isRegion;
